<template lang="pug">
  button(@click="$emit('click')")
    Icon(name="sort" pointer)
</template>

<script>
export default {
  name: 'BtnResort',
};
</script>

<style scoped lang="scss">
  button {
    width: 21px;
    height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: .5;
    border: 1px solid #92A0B0;
    border-radius: 4px;
    transition: opacity .1s linear;
    background: transparent;
    cursor: pointer;

    &:not([disabled]):hover {
      opacity: 1;
    }

    &:disabled:hover, &:disabled:hover svg {
      cursor: not-allowed !important;
    }
  }
</style>
